__webpack_require__.p = "/jornalismo-assets/";